// @givmo/app-charity — subtle "you edited this" provenance hint (CPA-WEB6, optional affordance).
//
// A tiny, unobtrusive line under a field whose current value was charity-entered (provenance `is_human`).
// Deliberately minimal — the profile GET's per-field provenance is surfaced as a quiet reassurance, not a
// heavy audit trail. Renders nothing when the field wasn't human-edited.

import { Icon } from '@givmo/design-system';
import { UserRound } from 'lucide-react';

export interface HumanEditedHintProps {
  /** Whether this field's current value was charity-entered (from provenance `is_human`). */
  show: boolean;
}

export function HumanEditedHint({ show }: HumanEditedHintProps) {
  if (!show) return null;
  return (
    <span className="mt-1 inline-flex items-center gap-4 font-sans text-s11 text-text-tertiary">
      <Icon icon={UserRound} size={11} aria-hidden />
      Edited by your organization
    </span>
  );
}
